import { api } from '@/api/client'
import type { OrderStatus } from '@/api/orders'

export interface DashboardStat {
  key: string
  value: number
  url: string | null
}

export interface DashboardAlert {
  kind: string
  severity: 'info' | 'warning'
  message: string
  url: string | null
  count: number
}

export interface DashboardOrder {
  id: string
  orderNumber: string
  supplierName: string
  status: OrderStatus
  itemCount: number
  requestedDeliveryDate: string | null
  createdAt: string
}

interface DashboardBase {
  greetingName: string
  organizationName: string
  stats: DashboardStat[]
  alerts: DashboardAlert[]
  recentOrders: DashboardOrder[]
}

export interface BusinessDashboard extends DashboardBase {
  cartItemCount: number
  cartOrderCount: number
  nextRecurringDate: string | null
  nextRecurringName: string | null
}

export interface SupplierDashboard extends DashboardBase {
  pickingItemCount: number
  pickingOrderCount: number
}

export type Dashboard = BusinessDashboard | SupplierDashboard

export function isSupplierDashboard(data: Dashboard): data is SupplierDashboard {
  return 'pickingOrderCount' in data
}

export const dashboardApi = {
  get: () => api.get<Dashboard>('/dashboard'),
}
